import type { AppOptions, DealRecord, Department } from "../types";

const departmentOrder: Department[] = ["ford", "subaru", "new_commercial", "used"];

function dealClass(department: Department): string {
  return `deal-card ${department.replace("_", "-")}`;
}

export default function DeskLogBoard({options, deals}: {options: AppOptions; deals: DealRecord[]}) {
  const bySlot = new Map<string, DealRecord[]>();
  for (const deal of deals) {
    const list = bySlot.get(deal.timeSlotId) ?? [];
    list.push(deal);
    bySlot.set(deal.timeSlotId, list);
  }

  return (
    <section className="panel">
      <div className="panel-heading">
        <div><span className="eyebrow">Live database view</span><h2>Today’s Desk Log</h2></div>
      </div>

      <div className="desk-grid">
        <div className="desk-header">Time</div>
        {departmentOrder.map((id) => <div className={`desk-header ${id.replace("_", "-")}`} key={id}>{options.departments.find((item) => item.id === id)?.name}</div>)}

        {options.timeSlots.map((slot) => {
          const slotDeals = bySlot.get(slot.id) ?? [];
          return (
            <div className="desk-row" key={slot.id}>
              <div className="desk-time">{slot.label}</div>
              {departmentOrder.map((department) => {
                const matches = slotDeals.filter((deal) => deal.department === department);
                return (
                  <div className="desk-cell" key={`${slot.id}-${department}`}>
                    {matches.map((deal) => (
                      <article className={dealClass(department)} key={deal.id}>
                        <strong>{deal.customer}</strong>
                        <span>{deal.vehicle}</span>
                        <small>{deal.salesperson} · {deal.fiManager}</small>
                      </article>
                    ))}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </section>
  );
}
